import { useEffect } from 'react';
import { useLang } from '@spa/i18n/useLang';
import { BioMarFishLoader } from '@spa/components/BioMarFishLoader';
import { BiomarLogo } from '@spa/components/BiomarLogo';

function PageLoader() {
  const t = useLang();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-center overflow-hidden"
      style={{
        background: `
    linear-gradient(
      to bottom,
      #4a8fb5 0%,
      #3a7a9e 8%,
      #2e6a8a 18%,
      #265f8f 30%,
      #1e4d7a 50%,
      #1a4270 65%,
      #1a3f6e 80%,
      #1a3d6b 100%
    )
  `,
      }}
    >
      <div
        className="absolute top-0 left-0 right-0 h-64 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 60% 40% at 50% 0%, rgba(150,210,235,0.12) 0%, transparent 70%)',
        }}
      />

      <BiomarLogo className="absolute top-6 left-6 w-22" />

      <div className="relative z-10 flex flex-col items-center">
        <div className="flex flex-col items-center text-center text-white">
          <p className="text-lg font-medium tracking-wide">
            {t('page.loading.title')}
          </p>
          <p className="text-sm tracking-wide">{t('page.loading.body')}</p>
        </div>

        <div className="translate-y-10">
          <BioMarFishLoader />
        </div>
      </div>
    </div>
  );
}

export default PageLoader;
